import React from "react";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import MapContainer from './MapContainer';
import {t} from "../IntManager";

export default class Contacts extends SeoComponent {
    render() {
        this.setMetaTags(t('main_title') + ' - ' + t('contacts'));

        return <LayoutComponent navReverse routerMatch={this.props.match}>
            <div className="contacts u-white-background">
                <div className="container contacts__wrapper relative">
                    <div className="contact-desc">
                        <h2 className="contact-desc__title u-bold">{t('find_us')}</h2>
                        <address className="contact-desc__address relative">
                            ул. Варварка, владение 6<br/>
                            Москва, 109012<br/>
                            Россия
                            <svg className="u-absolute u-pos-tl u-stroke--white" width="24" height="24">
                                <use xlinkHref="/static/media/svg-symbols.svg#pin"/>
                            </svg>
                        </address>
                        <a href="tel:+74955310950" className="contact-desc__meta relative">
                            +7 495 531-09-50
                            <svg className="u-absolute u-pos-tl u-stroke--white" width="24" height="24">
                                <use xlinkHref="/static/media/svg-symbols.svg#phone"/>
                            </svg>
                        </a>
                        <div className="contact-desc__meta relative">
                            {t('daily')} {t('from')} 12:00 {t('to')} 00:00
                            <svg className="u-absolute u-pos-tl u-stroke--white" width="24" height="24">
                                <use xlinkHref="/static/media/svg-symbols.svg#clock"/>
                            </svg>
                        </div>
                    </div>
                    <div className="wrap-map relative" id={'mapContainer'}>
                        <MapContainer/>
                    </div>
                </div>
            </div>
        </LayoutComponent>;
    }
}



// WEBPACK FOOTER //
// ./src/js/components/Contacts.js